import Permissions from 'src/utilities/permissions'

const sidebarLinks = []

export function projectsLinks() {
  return {
    name: 'Projects',
    icon: 'nc-icon nc-layout-11',
    path: '/projects'
  }
}

export function jobsLinks(can) {
  const jobMenu = {
    name: 'Jobs',
    icon: 'nc-icon nc-ruler-pencil',
    path: '/jobs/search',
    children: []
  }

  if (can('read', Permissions.JOBS)) {
    jobMenu.children.push({
        name: 'Search',
        path: '/jobs/search'
      })
  }

  if (can('read', Permissions.JOB_TEMPLATES)) {
    jobMenu.children.push({
      name: 'Templates',
      path: '/jobs/templates'
    })
  }

  if (jobMenu.children.length === 0) {
    return null
  }

  return jobMenu
}

export function tasksLinks() {
  return {
    name: 'Tasks',
    icon: 'nc-icon nc-bullet-list-67',
    path: '/tasks',
    children: [
      {
        name: 'My Tasks',
        path: '/tasks/my-tasks'
      },
      {
        name: 'Search',
        path: '/tasks/search'
      }
    ]
  }
}

export function invoicesLinks(can) {
  const links = []

  if (can('read', Permissions.INVOICES)) {
    links.push({
        name: 'Search',
        path: '/invoices/search'
      })
  }

  if (can('create', Permissions.INVOICES)) {
    links.push({
      name: 'Create',
      path: '/invoices/create'
    })
  }

  return {
    name: 'Invoices',
    icon: 'nc-icon nc-money-coins',
    path: '/invoices/create',
    children: links
  }
}

export function inTouchLinks() {
  return {
    name: 'InTouch GPS',
    icon: 'nc-icon nc-pin-3',
    path: '/in-touch'
  }
}

export function adminLinks(can) {
  const adminMenu = {
    name: 'Admin',
    icon: 'nc-icon nc-settings-gear-65',
    path: '/admin',
    children: null
  }

  const links = []

  if (can('read', Permissions.CAMUNDA)) {
    links.push({
      name: 'Camunda',
      path: '/admin/camunda-deployments'
    })
  }

  if (can('read', Permissions.CITIES)) {
    links.push({
      name: 'Cities',
      path: '/admin/cities'
    })
  }

  if (can('read', Permissions.COMMUNITIES)) {
    links.push({
      name: 'Communities',
      path: '/admin/communities'
    })
  }

  if (can('read', Permissions.COMPANIES)) {
    links.push({
      name: 'Companies',
      path: '/admin/companies'
    })
  }

  if (can('read', Permissions.DASHBOARD)) {
    links.push({
      name: 'Dashboard',
      path: '/admin/dashboard'
    })
  }

  if (can('read', Permissions.FILES)) {
    links.push({
      name: 'Files',
      path: '/admin/files'
    })
  }

  if (can('read', Permissions.IDA)) {
    links.push({
      name: 'IDA Archive',
      path: '/admin/ida-archive'
    })
  }

  if (can('read', Permissions.INSPECTOR_APP)) {
    links.push({
      name: 'Inspector App',
      path: '/admin/inspector-app'
    })
  }

  if (can('read', Permissions.INSPECTOR_ROUTING)) {
    links.push({
      name: 'Inspector Routing',
      path: '/admin/inspector-routing'
    })
  }

  if (can('read', Permissions.LEGAL_SUBDIVISIONS)) {
    links.push({
      name: 'Legal Subdivisions',
      path: '/admin/legal-subdivisions'
    })
  }

  if (can('read', Permissions.PLAN_NAMES)) {
    links.push({
      name: 'Plan Names',
      path: '/admin/plan-names'
    })
  }

  if (can('read', Permissions.PRICE_RULES)) {
    links.push({
      name: 'Price Rules',
      path: '/admin/price-rules'
    })
  }

  if (can('read', Permissions.QB.ITEM_CODES)) {
    links.push({
      name: 'QuickBooks',
      path: '/admin/quickbooks/item-codes'
    })
  }

  if (can('read', Permissions.REPORTS)) {
    links.push({
      name: 'Reports',
      path: '/admin/reports'
    })
  }

  if (can('read', Permissions.STREETS)) {
    links.push({
      name: 'Streets',
      path: '/admin/streets'
    })
  }

  if (can('read', Permissions.SUPPLY_PRO)) {
    links.push({
      name: 'Supply Pro',
      path: '/admin/supply-pro'
    })
  }

  if (can('read', Permissions.TASK_NAMES)) {
    links.push({
      name: 'Task Names',
      path: '/admin/task-names'
    })
  }

  if (can('read', Permissions.TASK_TEMPLATES)) {
    links.push({
      name: 'Task Templates',
      path: '/admin/task-templates'
    })
  }

  if (can('read', Permissions.USERS)) {
    links.push({
      name: 'Users',
      path: '/admin/users'
    })
  }

  adminMenu.children = links

  if (adminMenu.children.length === 0) {
    return null
  }

  return adminMenu
}

export default sidebarLinks
